import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import { makeSelectQueryStringBooleanValue } from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

// Components
// @ts-ignore
import DeleteTimesheetEntriesForm from './components/DeleteTimesheetEntriesForm';

interface OwnProps {
    onSubmit: Function;
}

interface ConnectedProps {
    open: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class DeleteTimesheetTimesheetEntriesModal extends React.PureComponent<
    Props
> {
    handleClose = (): void => {
        this.props.updateQueryString({
            deleteTimesheetEntriesModal: undefined
        });
    };

    render(): React.ReactElement {
        const { open, onSubmit } = this.props;
        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    open={open}
                    onClose={this.handleClose}
                    size="tiny"
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="ApproveTimesheetEntriesModal"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Modal.Header>Delete Timesheet Entry</Modal.Header>
                        <Modal.Content>
                            <p>Are you sure you want to delete the selected Timesheet Entry?</p>
                            <DeleteTimesheetEntriesForm
                                onClose={this.handleClose}
                                onSubmit={onSubmit}
                            />
                        </Modal.Content>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    open: makeSelectQueryStringBooleanValue('deleteTimesheetEntriesModal')
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(DeleteTimesheetTimesheetEntriesModal);
